import { THREADS } from '@/lib/socialProfile';

import { DefaultAvatar as Avatar } from '@/components/base/Avatar';
// Components
import Icon from '@/components/base/Icon';
import { CaptionPreview } from '@/components/composite/CaptionPreview';

type ThreadsPost = {
    caption_formatted?: string;
    data?: {
        caption?: string;
        mentions?: any[];
    };
    social_profile?: {
        slug?: string;
        external_api_data?: {
            avatar?: string;
            username?: string;
        };
    };
};

type PreviewThreadsProps = {
    post?: ThreadsPost;
    isLoading?: boolean;
};

const ContentWrapper = ({ children }: { children: React.ReactNode }) => (
    <div
        className="group relative flex min-h-[400px] w-full flex-col rounded-2xl bg-[#101010] p-4"
        aria-label="preview-threads">
        {children}
    </div>
);

const ThreadsHeader = ({ post }: { post?: ThreadsPost }) => (
    <div className="mb-4 flex items-center space-x-3">
        <Avatar
            url={post?.social_profile?.external_api_data?.avatar}
            fallback={post?.social_profile?.slug?.charAt(0) ?? 'U'}
            profileType="threads"
            className="h-10 w-10"
        />
        <div className="flex flex-col">
            <span className="font-GMedium text-sm text-white">
                {post?.social_profile?.external_api_data?.username ||
                    post?.social_profile?.slug ||
                    'username'}
            </span>
            <span className="text-xs text-gray-500">Nouveau thread</span>
        </div>
    </div>
);

const ThreadsActions = () => (
    <div className="mb-2 mt-4 flex items-center space-x-6">
        <Icon icon="heart" className="h-6 w-6 text-gray-400" />
        <Icon icon="message-circle" className="h-6 w-6 text-gray-400" />
        <Icon icon="repeat" className="h-6 w-6 text-gray-400" />
        <Icon icon="send" className="h-6 w-6 text-gray-400" />
    </div>
);

export const PreviewThreads = ({ post, isLoading }: PreviewThreadsProps) => {
    if (isLoading) {
        return <span className="square block animate-pulse rounded-2xl bg-[#101010]" />;
    }

    return (
        <ContentWrapper>
            <ThreadsHeader post={post} />
            <CaptionPreview
                caption={post?.data?.caption ?? post?.caption_formatted ?? ''}
                network={THREADS}
                mentions={post?.data?.mentions ?? []}
                className="text-[17px] leading-[22px] text-[#E7E9EA]"
            />
            <ThreadsActions />
        </ContentWrapper>
    );
};

export default PreviewThreads;
